import React from "react";
import { EmptyComponent } from "../common/EmptyComponent";
import Loadable from "react-loadable";
import { useSelector } from "react-redux";
import { UISelectors, UserContextSelectors } from "../../redux/selectors";
import { PageContextUtils } from "../../utils";
import { processClientIcons } from "../../managers/iconManager";
import { useFeature } from "../../hooks/useFeature";
import { AppFeatures } from "../../constants/featureFlags";
import QuickLinksMenu from "../MenuV2/QuickLinksMenu";

export const HamburgerDrawerChunk = Loadable({
  loader: () => {
    processClientIcons();

    return import(
      /* webpackChunkName: "drawer/hamburger" */
      /* webpackPrefetch: true */
      "./HamburgerDrawer"
    );
  },

  loading: EmptyComponent
});

export const LanguageDrawerChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "drawer/language" */
      "./LanguageDrawer"
    ),
  loading: EmptyComponent
});

export const QuickLinksInnerDrawerChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "drawer/quicklinks" */
      /* webpackPrefetch: true */
      "./QuickLinksInnerDrawer"
    ),
  loading: EmptyComponent
});

export const SportAZMenuChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "drawer/sportaz-menu" */
      /* webpackPrefetch: true */
      "../MenuV2/SportAZMenu"
    ),
  loading: EmptyComponent
});

export const MyAccountDrawerChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "drawer/my-account.drawer" */
      /* webpackPrefetch: true */
      "./MyAccountAreaDrawer"
    ),
  loading: EmptyComponent
});

export const SettingsDrawerChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "drawer/settings" */
      /* webpackPrefetch: true */
      "./SettingsDrawer"
    ),
  loading: EmptyComponent
});

const Drawers = () => {
  const userInteracted = useSelector(UISelectors.userInteracted);
  const { myAccountAreaComponents } = PageContextUtils.getVisualData();
  const isSettingsDrawerEnabled = useFeature(AppFeatures.SETTINGS_DRAWER);
  const isMobile = useSelector(UserContextSelectors.isMobile);

  return (
    userInteracted && (
      <>
        {isMobile ? (
          <>
            <HamburgerDrawerChunk />

            {!isSettingsDrawerEnabled && <LanguageDrawerChunk />}
            <QuickLinksInnerDrawerChunk />
          </>
        ) : (
          <QuickLinksMenu />
        )}
        {myAccountAreaComponents && <MyAccountDrawerChunk />}
        {isSettingsDrawerEnabled && <SettingsDrawerChunk />}
      </>
    )
  );
};

export default React.memo(Drawers);
